module.exports = __webpack_public_path__ + "img/email.958005f3.svg";